invHdApp.controller('StationController', ['$scope', 'Station', '$location', '$routeParams', '$filter', '$translate',
  function ($scope, Station, $location, $routeParams, $filter, $translate) {
    $scope.deleted = [];
    var componentForm = {
      street_number: 'short_name',
      route: 'long_name',
      locality: 'long_name',
      administrative_area_level_1: 'short_name',
      administrative_area_level_2: 'short_name',
      country: 'long_name',
      postal_code: 'short_name'
    };
    var mapping = {
      street_number: 'number',
      route: 'street',
      locality: 'state',
      administrative_area_level_1: 'city',
      administrative_area_level_2: 'district',
      country: 'country',
      postal_code: 'zip'
    };

    $scope.filterData = {
      customers: [],
      workers: [],
      workSteps: [],
      page: 1,
      created_at: {
        startDate: null,
        endDate: null
      },
      scheduled_time: {
        startDate: null,
        endDate: null
      }
    }


    $scope.getPage = function (page) {
      $scope.filterData.page = page;
      $scope.filter();
    }

    $scope.sort = function (field, sort) {
      $scope.filterData.field = field;
      $scope.filterData.sort = sort;
      $scope.filter();
    }

    $scope.filter = function (type) {
      if (type == 'clear') {
        $scope.filterData = {
          customers: [],
          companies: [],
          page: 1,
        }
        $scope.filterProp = [];
      } else {
        $scope.filterData.filterProp = $scope.filterProp;
        if (typeof $scope.filterData.created_at.endDate !== 'undefined' && $scope.filterData.created_at.endDate !== null) {
          $scope.filterData.filterProp.created_at = 'created_at';
        }
        if (typeof $scope.filterData.scheduled_time.endDate !== 'undefined' && $scope.filterData.scheduled_time.endDate !== null) {
          $scope.filterData.filterProp.scheduled_time = 'scheduled_time';
        }
      }
      $scope.all();
    }

    $scope.$on('refresh_data', function () {
      console.log('refreshing stations...')
      $scope.all();
    }, true);

    $scope.all = function () {
      Station.all($scope.filterData).success(function (data, status, headers, config) {
        $scope.data = data;
        if (typeof $scope.filterData.filterProp !== 'undefined') {
          $scope.filterProp = [];
          if (angular.isArray($scope.filterData.filterProp)) {
            for (var i = $scope.filterData.filterProp.length - 1; i >= 0; i--) {
              $scope.filterProp.push($scope.filterData.filterProp[i])
            }
          } else {
            $scope.filterProp.push($scope.filterData.filterProp);
          }
        }
      });
    }

    $scope.openDetail = function (item) {
      Station.get(item.id).success(function (data, status, headers, config) {
        $('#stationModal').modal('show');
        $scope.station = data.station;
        $scope.formData = {};
        $scope.formData.cities = data.cities;
        Station.getCityDistricts({
          city: data.station.city
        }).success(function (data, status, headers, config) {
          $scope.formData.districts = data.districts;
          $scope.station.zipcodes.forEach(element => {
            var find = data.districts.find(i => i.name == element.zipcode)
            console.log('find', find, element, data.districts)
            element.zipcode_id = JSON.stringify(find);
            element.neighbourhoods_ids = element.neighbourhoods
            Station.getNeighbourhood({
              district_id: find.id,
            }).success(function (data, status, headers, config) {
              element.neighbourhoods = data.neighbourhoods;
            });
          });
        });
      });
    }

    $scope.$on('new_data', function () {
      $('#stationModal').modal('show');
      $scope.new();
    }, true);

    $scope.new = function () {
      Station.new().success(function (data, status, headers, config) {
        $scope.formData = data;
        $scope.station = {
          'city': 'İstanbul',
          'zipcodes': []
        };
      });
    }

    $scope.getCityDistricts = function () {
      var city = JSON.parse($scope.station.city_id);
      $scope.station.city = city.name;
      Station.getCityDistricts({
        city_id: city.id
      }).success(function (data, status, headers, config) {
        $scope.formData.districts = data.districts;
      });
    }

    $scope.getNeighbourhood = function (elem) {
      var district = JSON.parse(elem.zipcode_id);
      elem.zipcode = district.name;
      Station.getNeighbourhood({
        district_id: district.id,
      }).success(function (data, status, headers, config) {
        elem.neighbourhoods = data.neighbourhoods;
      });
    }

    $scope.getAddress = function (address) {
      if (typeof address.latitude !== 'undefined') {
        var location = new google.maps.LatLng(address.latitude, address.longitude);
        $scope.map.setCenter(location);
        $scope.marker.setDuration(1000);
        $scope.marker.setEasing("swing");
        $scope.marker.setPosition(location);
        // angular.merge($scope.station, address);
        if ($scope.station) {
          angular.merge($scope.station, address);
          $scope.station.city = address.city;
          $scope.station.state = address.state;
          $scope.station.address = address.address;
          $scope.station.zipcode = address.zipcode ? address.zipcode : address.zip;
          $scope.states.forEach(element => {
            if (element.abbreviation == address.city) {
              $scope.station.state = element.name;
              return true;
            }
          });
        } else {
          angular.merge($scope.station, address);
          $scope.station.city = address.city;
          $scope.station.state = address.state;
          $scope.station.address = address.address;
          $scope.station.zipcode = address.zipcode ? address.zipcode : address.zip;
          $scope.states.forEach(element => {
            if (element.abbreviation == address.city) {
              $scope.station.state = element.name;
              return true;
            }
          });
        }
      }
    }

    $scope.delete = function (type) {
      if (type == 'set') {
        $('#delete').modal('show');
      } else if (type == 'delete') {
        Station.delete($scope.deleted).success(function (data, status, headers, config) {
          Messenger().post('Başarılı');
          for (var i = $scope.deleted.length - 1; i >= 0; i--) {
            var index = $scope.data.stations.indexOf($filter('filter')($scope.data.stations, {
              id: $scope.deleted[i]
            })[0]);
            if (index > -1) {
              $scope.data.stations.splice(index, 1);
            }
          }
          $scope.deleted = [];
          $('#delete').modal('hide');
        }).error(function (data) {
          Messenger().post({
            message: data.message,
            type: "error"
          });
        });
      }
    }

    $scope.postForm = function (user) {
      if ($scope.station.id) {
        $scope.update();
      } else {
        $scope.save();
      }
    }

    $scope.save = function () {
      Station.save($scope.station).success(function (data, status, headers, config) {
        $scope.data = data;
        Messenger().post('Başarılı');
        $('#stationModal').modal('hide');
        $scope.all();
      }).error(function (data) {
        Messenger().post({
          message: data.message,
          type: "error"
        });
      });
    }

    $scope.update = function () {
      Station.update($scope.station).success(function (data, status, headers, config) {
        $scope.data = data;
        Messenger().post('Başarılı');
        $('#stationModal').modal('hide');
        $scope.all();
      }).error(function (data) {
        Messenger().post({
          message: data.message,
          type: "error"
        });
      });
    }

    $scope.toggleSelection = function toggleSelection(id) {
      var idx = $scope.deleted.indexOf(id);
      if (idx > -1) {
        $scope.deleted.splice(idx, 1);
      } else {
        $scope.deleted.push(id);
      }
    };

    $scope.addItem = function () {
      $scope.station.zipcodes.push({
        zipcode: null,
      });
    }

    $scope.removeItem = function (index) {
      $scope.station.zipcodes.splice(index, 1);
    }

  }
]);